<template>
  <div class="evaluate-pannel">
    <div class="evaluate-container">
      <div class="evaluate-title">
        <div style="width: 70%;margin: 15px auto 0;" v-if="initialData.calling_config.evaluate_auto === '1'">{{initialData.calling_config.evaluate_content}}</div>
        <!-- <svg-icon
          @click.native="goback"
          class="evaluate-pannel-close"
          icon-class="closeBlack"
        ></svg-icon> -->
      </div>
      <div class="evaluate-level clearfix">
        <div @click="setEvaluateLevel('1')">
          <div>
            <svg-icon v-if="evaluateLevel == '1'" icon-class="evaluateWorseActive" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
            <svg-icon v-else icon-class="evaluateWorse" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
          </div>
        </div>
        <div @click="setEvaluateLevel('2')">
          <div>
            <svg-icon v-if="evaluateLevel == '2'" icon-class="evaluateLessActive" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
            <svg-icon v-else icon-class="evaluateLess" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
          </div>
        </div>
        <div @click="setEvaluateLevel('3')">
          <div>
            <svg-icon v-if="evaluateLevel == '3'" icon-class="evaluateNormalActive" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
            <svg-icon v-else icon-class="evaluateNormal" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
          </div>
        </div>
        <div @click="setEvaluateLevel('4')">
          <div>
            <svg-icon v-if="evaluateLevel == '4'" icon-class="evaluateSatisfiedActive" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
            <svg-icon v-else icon-class="evaluateSatisfied" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
          </div>
        </div>
        <div @click="setEvaluateLevel('5')">
          <div>
            <svg-icon v-if="evaluateLevel == '5'" icon-class="evaluateVeryActive" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
            <svg-icon v-else icon-class="evaluateVery" style="width: 30px;height: 30px;margin: 0;"></svg-icon>
          </div>
        </div>
      </div>
      <div class="evaluate-level-name">
        <span class="very" v-if="evaluateLevel == 5">
          <svg-icon icon-class="eval-very"></svg-icon>非常满意
        </span>
        <span class="satisfied" v-if="evaluateLevel == 4">
          <svg-icon icon-class="eval-satisfied"></svg-icon>比较满意
        </span>
        <span class="normal" v-if="evaluateLevel == 3">
          <svg-icon icon-class="eval-normal"></svg-icon>一般
        </span>
        <span class="less" v-if="evaluateLevel == 2">
          <svg-icon icon-class="eval-less"></svg-icon>比较不满意
        </span>
        <span class="worse" v-if="evaluateLevel == 1">
          <svg-icon icon-class="eval-worse"></svg-icon>非常不满意
        </span>
      </div>
      <div class="evaluate-quick-content clearfix" :class="renderLevelClass(evaluateLevel)">
        <span @click="chooseEval(item)" v-for="(item, index) in evaluateItem" :class="renderActiveClass(item)" :key="index">{{item.evaluateTagName}}</span>
        <span @click="toggleClick" :class="customEval ? 'tagActive' : ''">写评价</span>
      </div>
      <div class="evaluate-content-wrap" v-if="customEval">
        <textarea class="evaluate-content" v-model="evaluateContent" rows="2" placeholder="请填写评价内容（选填）" id></textarea>
      </div>
      <div class="evaluate-submit">
        <span @click="sendEvaluate" :class="(evaluateLevel != '0' && !evaluateSubmitted) ? '' : 'btnDisabled'">提交评价</span>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        evaluateLevel: "5", // 评价等级
        evaluateContent: "", // 评价内容
        evaluateItem: [],
        chooseEvaluate: [],
        quickEvaluate: {},
        customEval: false,
        evaluateSubmitted: false, // 评价已提交
        initialData:"",
      }
    },
    created() {
      this.getQuickEvaluate()
      this.getInitialData()
      this.getPageTitle()
      this.evaluateSubmitted = this.$utils.GetQueryString("isEvaluate")==1? true : false
    },
    methods: {
      goback() {
        window.history.back();
      },
      setEvaluateLevel(val) {
        this.evaluateItem = this.quickEvaluate[val];
        this.evaluateLevel = val;
        this.chooseEvaluate = [];
      },
      renderLevelClass(val) {
        switch (val) {
          case "1":
          case 1:
            return "wrapWorse";
          case "2":
          case 2:
            return "wrapLess";
          case "3":
          case 3:
            return "wrapNormal";
          case "4":
          case 4:
            return "wrapSatisfied";
          case "5":
          case 5:
            return "wrapVery";
        }
      },
      renderActiveClass(item) {
        if (this.chooseEvaluate.indexOf(item) > -1) {
          return "tagActive";
        }
      },
      toggleClick() {
        this.customEval = !this.customEval;
      },
      chooseEval(item) {
        if (this.chooseEvaluate.indexOf(item) > -1) {
          this.chooseEvaluate.splice(this.chooseEvaluate.indexOf(item), 1);
        } else {
          this.chooseEvaluate.push(item);
        }
      },
      getPageTitle() {
        this.$http.getPageTitleAPI({
          cid:Number(this.$utils.GetQueryString("cid"))
        }).then(res => {
          if(res.status==1){
            document.title = res.data || '微聊客服'
          }
        })
      },
      getInitialData() {
        this.$http.getInitialDataAPI({
          cid:Number(this.$utils.GetQueryString("cid"))
        }).then(res => {
          console.log(res)
          if(res.status==1){
            this.initialData = res.data
          }
        })
      },
      // 获取快速评价
      getQuickEvaluate() {
        this.$http.getQuickEvaluateAPI({
          cid: this.$utils.GetQueryString("cid")
        }).then(res => {
          console.log(res)
          if (res.status == 1) {
            this.quickEvaluate = res.data;
            this.evaluateItem = res.data[this.evaluateLevel];
          }
        });
      },
      // 提交评价
      sendEvaluate() {
        if (!this.evaluateSubmitted) {
          if (this.evaluateLevel === "0") {
            this.$toast.fail("请先选择评价等级");
            return false;
          }
          if (!this.customEval) {
            this.evaluateContent = "";
          }
          let tagIds = [];
          this.chooseEvaluate.map(item => {
            tagIds.push(item.id);
          });
          let postData = {
            visitorId: this.$utils.GetQueryString("visitorId"),
            servicerId: this.$utils.GetQueryString("serviceId"),
            callingNo: this.$utils.GetQueryString("callingNo"),
            sign: this.$utils.GetQueryString("sign"),
            grade: Number(this.evaluateLevel),
            content: this.evaluateContent,
            tagIds: tagIds,
            cid: this.$utils.GetQueryString("cid")
          };
          this.$http.chatEvaluateAPI(postData).then(res => {
            if (res.status === "1") {
              this.evaluateSubmitted = true;
              this.$toast.success(res.msg);
            }else{
              this.$toast.fail(res.msg);
            }

          });
        }
      },
    }
  }
</script>

<style lang="scss">
  .evaluate-pannel {
    width: 100%;
    height: 100%;
    .evaluate-container {
      background-color: #fff;
      height: 100%;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 15px;
      box-sizing: border-box;
      overflow-y: auto;

      .evaluate-title {
        text-align: center;
        font-size: 16px;
        color: #333;
        position: relative;

        .evaluate-pannel-close {
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
        }
      }

      .evaluate-level {
        text-align: center;
        padding: 10px 0;
        width: 240px;
        margin: 0 auto;
        box-sizing: border-box;
        font-size: 12px;
        color: #666;

        &>div {
          float: left;
          cursor: pointer;
          width: 45px;
          padding: 10px 0 6px;
          border: 1px solid #fff;

          &.chosen {
            background-color: #fafafa;
            border: 1px solid #f0f0f0;
            border-radius: 4px;
          }
        }

        .level-title {
          padding-top: 10px;
          box-sizing: border-box;
        }
      }

      .evaluate-level-name {
        text-align: center;
        font-size: 12px;
        padding-bottom: 5px;
        box-sizing: border-box;

        span {
          color: #428efe;
          /*&.satisfied {
                color: $colorSatisfied;
              }

              &.very {
                color: $colorVery;
              }

              &.normal {
                color: $colorNormal;
              }

              &.less {
                color: $colorLess;
              }

              &.worse {
                color: $colorWorse;
              }*/
        }
      }

      .evaluate-quick-content {
        font-size: 13px;
        padding-bottom: 15px;
        text-align: center;

        span {
          cursor: pointer;
          display: inline-block;
          background-color: #eaf2ff;
          /*background-color: #efefef;*/
          /*color: #505050;*/
          color: #428efe;
          padding: 10px 19px;
          border-radius: 16px;
          margin-top: 10px;
          margin-right: 10px;
        }

        &.wrapVery {
          .tagActive {
            background-color: #428efe;
            color: #fff;
          }
        }

        &.wrapSatisfied {
          .tagActive {
            background-color: #428efe;
            color: #fff;
          }
        }

        &.wrapNormal {
          .tagActive {
            background-color: #428efe;
            color: #fff;
          }
        }

        &.wrapLess {
          .tagActive {
            background-color: #428efe;
            color: #fff;
          }
        }

        &.wrapWorse {
          .tagActive {
            background-color: #428efe;
            color: #fff;
          }
        }
      }

      .evaluate-content-wrap {
        /*height: 40%;*/
      }

      .evaluate-content {
        resize: none;
        width: 100%;
        border: 1px solid #e5e5e5;
        font-size: 12px;
        border-radius: 4px;
        padding: 8px;
        outline: none;
        line-height: 16px;
        box-sizing: border-box;
        background: none;
      }

      .evaluate-submit {
        text-align: center;
        padding-top: 15px;

        span {
          width: 80%;
          display: inline-block;
          font-size: 14px;
          padding: 10px 15px;
          text-align: center;
          color: #fff;
          cursor: pointer;
          background-color: #488bff;
          border-radius: 8px;

          &.btnDisabled {
            background-color: #dae4ed;
            cursor: not-allowed;
          }
        }
      }
    }
  }
</style>
